import { Box } from "@mui/material";
import { useState } from "react";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { salesManagement } from "../../../config";

const base_url = salesManagement.uri;

const SaleOrdersAuditsQuery = `{
   allSaleOrdersAudits {
    auditDate
    auditId
    branchId
    cancelled
    changedColumns
    changedData
    clientIP
    companyId
    customerId
    dbUser
    externalSaleAmount
    hasExternalSale
    inventoryUpdatedBy
    inventoryUpdatedByUsername
    inventoryUpdatedDate
    isBackdated
    isCredit
    isInventoryUpdated
    isInvoiced
    isMpesaPaid
    isPaid
    isReversed
    isWarehouse
    newData
    oldData
    operation
    outstanding
    paymentMethodId
    reason
    regionId
    saleOrderId
    source
    totalAmount
    updatedBy
    updatedByUsername
    updatedDate
    userId
    username
  }
  }
`;
const actions = {
  entity: "SaleOrderAudits",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button:false,
    permission: "ActivatePermission",
    modelName: "colorIds",
    inputObjectName: "bulkActivateDeactivateColor",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Inventory Details"
  },
  showStatus: true,
};
const ignore = [ "branchId", "changedColumns", "clientIP", "companyId", "dbUser",  "inventoryUpdatedBy", "productId", "regionId", "source", "userId", "newData", "oldData", "purchaseOrderItemsId" ,"reason"];

function SalesOrdersAuditsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  return (
    <Box m="2px">
      <DynamicTable
        title="Sales Orders Audits"
        subtitle="Manage sales orders audits"
        // FormComponent={ColorForm}
        query={SaleOrdersAuditsQuery}
        base_url={base_url}
        actions={actions}
        ignoreFields={ignore}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        getRowId={(row) => row.auditId}

      />
    </Box>
  );
}

export default SalesOrdersAuditsTable;
